import store from '@/store';
import Layout from "./views/Layout.vue";
import defaultUser from "./defaultUser.json";
import { USE_MOBILE_WORKOUT_UI } from "@/module_user/uitls/constants";
import { USE_DESKTOP_WORKOUT_UI } from "@/module_user/uitls/constants";
import {devicesMixin} from "@/utils/devices";

const APP_NAME = 'EliteFit.AI - ';

const routes = [
  {
    path: '/subscription-plans',
    component: () => import('./views/EndUserSubscriptionPlans.vue'),
    name: "EndUserSubscriptionPlans"
  },
  {
    path: '/join/:corporate/:promocode',
    component: () => import('./components/Promocode.vue'),
    name: "JoinEliteFit"
  },
  {
    path: '/ef/sign-up',
    component: () => import('../views/SignUp.vue'),
    name: "SignUp",
    meta: {
      title: APP_NAME + "Sign Up",
    },
    beforeEnter: checkUserLogin,
  },
  {
    path: '/smb/sign-in/:type?',
    component: () => import('../views/SMBSignIn/SignIn.vue'),
    name: "SMB Sign In",
    meta: {
      title: APP_NAME + "SMB Sign In",
    },
  },
  {
    path: '/smb/sign-up/:type?',
    component: () => import('../views/SMBSignIn/SignUp.vue'),
    name: "SMB Sign Up",
    meta: {
      title: APP_NAME + "SMB Sign Up",
    },
  },
  {
    path: '/:corporate/sign-up',
    component: () => import('../views/SignUp.vue'),
    name: "SignUp",
    meta: {
      title: APP_NAME + "Sign Up",
    },
    beforeEnter: checkUserLogin,
  },
  {
    path: '/ef/sign-in',
    component: () => import('../views/SignIn.vue'),
    name: "SignIn",
    meta: {
      title: APP_NAME + "Sign In",
    },
    beforeEnter: checkUserLogin,
  },
  {
    path: '/:corporate/sign-in',
    component: () => import('../views/SignIn.vue'),
    name: "SignIn",
    meta: {
      title: APP_NAME + "Sign In",
    },
    beforeEnter: checkUserLogin,
  },
  {
    path: '/:corporate/partner-login',
    component: () => import('../views/SignInWithSessionID.vue'),
    name: "SessionIDSignIn",
    meta: {
      title: APP_NAME + "Sign In",
    },
    beforeEnter: checkUserLogin,
  },
  {
    path: '/complete-profile',
    component: () => import('./views/CompleteProfile.vue'),
    name: "Complete Profile",
    meta: {
      title: APP_NAME + "Complete Profile",
    },
    beforeEnter: checkUserLogin,
  },
  {
    path: '/smb/microsite',
    component: () => import('../views/SMBSignIn/Microsite.vue'),
    name: "SMB Microsite",
    meta: {
      title: APP_NAME + "SMB Microsite",
    }
  },
  {
    path: '/subscription-plans',
    component: () => import('./views/StripeSubscriptionPlans.vue'),
    name: "SubscriptionPlans",
    meta: {
      title: APP_NAME + "Subscription Plans",
    },
  },
  {
    path: '/customer-portal',
    redirect: (to) => {
      const id = process.env.VUE_APP_STRIPE_CLIENT_PORTAL;
      window.location.href = `https://billing.stripe.com/p/login/${id}`;
    }
  },
  // {
  //   path: '/tnx/:status/:id',
  //   component: () => import('./views/TransactionDetails.vue'),
  //   name: "TransactionDetails",
  //   meta: {
  //     title: APP_NAME + "Transaction Details",
  //   },
  // },
  {
    path: "/workout/dualuser",
    name: "MultiUserWorkout",
    component: () => import("./views/MultiUserWorkout.vue"),
  },
  {
    path: "/workout/dualuser/v2",
    name: "MultiUserWorkout",
    component: () => import("./views/MultiUserWorkoutV2.vue"),
  },
  {
    path: "/user/end-workout/v2",
    component: () => {
      return import("./views/EndWorkout_V2.vue");
    },
    beforeEnter: checkUserLogin,
    name: "EndWorkout V2",
    meta: {
      title: APP_NAME + "End Workout",
    },
  },
  {
    path: "",
    component: Layout,
    redirect: getRedirectTo,
    children: [
      {
        path: '/push-ups',
        component: () => import('../views/PushUps.vue'),
        name: "Push-Ups",
        meta: {
          title: APP_NAME + "Push-Ups rep counter demo",
        },
      },
      {
        path: '/sit-to-stand',
        component: () => import('../views/SitToStand'),
        name: "SitToStand",
        meta: {
          title: APP_NAME + "Sit to stand rep counter demo",
        },
      },
      {
        path: '/rep-counter',
        component: () => import('../views/RepCounter.vue'),
        name: "RepCounter",
        meta: {
          title: APP_NAME + "Push-Ups rep counter demo",
        },
      },
      // {
      //   path: '/home',
      //   component: () => import('@/module_homepage/views/Home4.vue'),
      //   beforeEnter: checkUserLogin,
      //   name: "Home",
      //   meta: {
      //     title: APP_NAME + "Workout with AI Don't settle for less",
      //   },
      // },
      {
        path: '/corporate',
        component: () => import('../views/Corporate.vue'),
        name: "Corporate",
        meta: {
          title: APP_NAME + "Corporate",
        },
      },
      {
        path: '/distributors',
        component: () => import('../views/Distributors.vue'),
        name: "Distributors",
        meta: {
          title: APP_NAME + "Distributors",
        },
      },
      {
        path: '/coaches',
        component: () => import('../views/Coaches.vue'),
        name: "about",
        meta: {
          title: APP_NAME + "Coaches",
        },
      },


      // AI Solutions
      {
        path: '/yoga',
        component: () => import('../views/AISolutions/Yoga.vue'),
        name: "AISolutionsYoga",
        meta: {
          title: APP_NAME + "Yoga",
        },
      },
      {
        path: '/sme',
        component: () => import('../views/AISolutions/SME.vue'),
        name: "AISolutionsSME",
        meta: {
          title: APP_NAME + "SME",
        },
      },
      {
        path: '/schools',
        component: () => import('../views/AISolutions/Schools.vue'),
        name: "AISolutionsSchools",
        meta: {
          title: APP_NAME + "Schools",
        },
      },

      // Resources


      //  Why EF

      {
        path: '/our-team',
        component: () => import('../views/WhyEF/OurTeam.vue'),
        name: "OurTeam",
        meta: {
          title: APP_NAME + "OurTeam",
        },
      },
      {
        path: '/ef/forgot-password',
        component: () => import('../views/ForgotPassword.vue'),
        name: "ForgotPassword",
        meta: {
          title: APP_NAME + "Forgot Password",
        },
      },
      {
        path: '/:corporate/forgot-password',
        component: () => import('../views/ForgotPassword.vue'),
        name: "ForgotPassword",
        meta: {
          title: APP_NAME + "Forgot Password",
        },
      },
      {
        path: '/ef/reset-password',
        component: () => import('../views/ResetPassword.vue'),
        props: route => ({ email: route.query.email, token: route.query.token }),
        meta: {
          title: APP_NAME + "Reset Password",
        },
      },
      {
        path: '/workout/rep',
        component: () => import('@/module_user/views/RepWorkout'),
        beforeEnter: checkUserLogin,
        name: "RepWorkout",
      },
      {
        path: '/workout/hold-rep',
        component: () => import('@/module_user/views/HoldRepWorkout'),
        beforeEnter: checkUserLogin,
        name: "HoldRepWorkout",
      },
      {
        path: '/workout/:tenant',
        component: () => {
          // check if env has flag true for new desktop UI or new mobile UI is true
          if (USE_DESKTOP_WORKOUT_UI || USE_MOBILE_WORKOUT_UI) {
            return import('@/module_user/views/Workout');
          }
          return import('./views/workoutoldui');
        },
        beforeEnter: checkUserLogin,
        props: route => ({ id: route.query.id, tryNow: false, withEFTech: 1, withAssist: 0, poseBy: "BP", showIntro: route.query.showIntro || false, videotype: route.query.videotype || 1 }),
        name: "workout",
      },
      {
        path: '/workoutIntro',
        component: () => {
          // check if device is mobile and env flag for new mobile UI is true
          if (isMobile() && USE_MOBILE_WORKOUT_UI) {
            return import('@/module_user/views/MobileWorkoutIntroduction');
          }
          // check if env has flag true for new desktop UI
          if (USE_DESKTOP_WORKOUT_UI) {
            return import('@/module_user/views/DesktopWorkoutIntroduction');
          }
          return import('./views/workoutoldui');
        },
        beforeEnter: checkUserLogin,
        props: route => ({ id: route.query.id, tryNow: false, withEFTech: 1, withAssist: 0, poseBy:"BP", showIntro : route.query.showIntro || false, videotype : route.query.videotype || 1,  }),
        name: "workoutIntro",
      },
      {
        path: '/shareResults',
        component: () => import('./views/EndWorkoutShareResults.vue'),
        beforeEnter: checkUserLogin,
        name: "shareResult",
      },
      // {
      //   path: '/workout-mobile/:tenant',
      //   component: () => import('./views/WorkoutMobile.vue'),
      //   beforeEnter: checkUserLogin,
      //   props: route => ({ id: route.query.id, tryNow: false, withEFTech: 1, withAssist: 0, poseBy:"BP" }),
      //   name: "workout Mobile",
      // },
      {
        path: '/end-workout-mobile',
        component: () => import('./views/EndWorkoutMobile.vue'),
        name: "EndWorkout Mobile",
      },
      
      {
        // Deprecated Route (Old layout)
        path: '/user-profile',
        component: () => import("./views/UserProfile.vue"),
        beforeEnter: checkUserLogin,
        name: "User Profile",
        children: [
          {
            path: "/user-profile/leaderboard",
            component: () => import("../module_admin/views/LeaderBoard.vue"),
            name: "leaderboard Old",
            meta: {
              title: APP_NAME + "Leaderboard",
            }
          },
          {
            path: "/user-profile/corporate-dashboard",
            component: () => import("./views/CorporateDashboard.vue"),
            name: "CorporateDashboard Old",
            meta: {
              title: APP_NAME + "Corporate Dashboard",
            }
          },
          {
            path: "/user-profile/progress",
            component: () => import("./views/UserProgress.vue"),
            name: "User Progress Old",
            meta: {
              title: APP_NAME + "User Progress",
            },
          },
          {
            path: "/user-profile/edit",
            component: () => import("./views/EditUserProfile.vue"),
            name: "Edit User Profile Old",
            meta: {
              title: APP_NAME + "Edit User Profile",
            },
          }
        ]
      },
      {
        path: '/about-us',
        component: () => import('./views/AboutUs.vue'),
        name: "About Us",
        meta: {
          title: APP_NAME + "About",
        },
      },
      {
        path: '/careers-old',
        component: () => import('./views/Careers.vue'),
        name: "Careers",
        meta: {
          title: APP_NAME + "Careers",
        },
      },
      {
        path: '/terms-of-use-old',
        component: () => import('./views/TnCs.vue'),
        name: "Terms Of Use",
        meta: {
          title: APP_NAME + "Terms Of Use",
        },
      },
      {
        path: '/privacy-policy-old',
        component: () => import('./views/PrivacyPolicy.vue'),
        name: "Privacy Policy",
        meta: {
          title: APP_NAME + "Privacy Policy",
        },
      },
      {
        path: '/ClientAgreement',
        component: () => import('./views/ClientAgreement.vue'),
        name: "Client Agreement",
        meta: {
          title: APP_NAME + "Client Agreement",
        },
      },
      {
        path: '/DistributorAgreement',
        component: () => import('../views/DistributorAgreement.vue'),
        name: "Distributor Agreement",
        meta: {
          title: APP_NAME + "Distributor Agreement",
        },
      },
      {
        path: '/youtube-demo',
        component: () => import('./views/YoutubeDemo.vue'),
        name: "Youtube Demo",
        meta: {
          title: APP_NAME + "Youtube Demo",
        },
      },
      // Disable discover for non-logged in users
      // {
      //   path: '/discover',
      //   component: () => import('@/module_user/views/DiscoverV2.vue'),
      //   name: 'Discover Anonymous',
      // }
    ]
  },
  {
    path: "/speech-demo",
    name: "SpeechDemo",
    component: () => import('./../views/TextToSpeechDemo.vue')
  },
];

export default routes;

export function requireAuth(to, from, next) {
  if (localStorage.getItem("token") == null) {
    next("/ef/sign-in");
  }
  // else if (store.state.userInfo && !store.state.userInfo.passwordChanged && to.path.indexOf('change-password') == -1) {
  //   next("/change-password");
  // }
  // else if (store.state.userInfo & !store.state.userInfo.goalType) {
  //   next("/profile");
  // }
  else {
    next();
  }
}

function isAnonymous() {
  if (store.state.userInfo) {
    return store.state.userInfo.isAnonymousUser;
  } else {
    return true;
  }
}

function isMobile() {
  return devicesMixin.computed.isMobile();
}

export async function checkUserLogin(to, from, next) {

  const localuserInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isUserInfoNotAvailable = (!localuserInfo || (localuserInfo && localuserInfo.length === 0) || Object.entries(localuserInfo).length === 0);
  // Pages that require user-data for direct access by link
  const directLinkPages = ['Home', 'Trainer Profile', 'workout', 'RepWorkout', 'HoldRepWorkout', 'SignIn', 'SessionIDSignIn', 'SignUp', 'workout Mobile'];

  // Check for user-data in web-storage. if not, create a Anonymous user
  if (isUserInfoNotAvailable) {
    let localuserInfo = defaultUser[0];
    store.dispatch('saveAnonymousUser', localuserInfo).then(() => {
      // console.log("token created");
    });
    if (!directLinkPages.includes(to.name)) {
      return next({ path: '/home' });
    }
  }

  else {

    /**
     * This array includes pages which user can't visit when he is logged in eg. sign-in & sign-up page
     * */
    const nonLoggedInPages = ['SignIn', 'SignUp'];

    /**
     * This array includes pages which user can only visit once he is logged in
     * */
    const loggedInPages = ['User Progress', 'Complete Profile'];

    /**
     * This array includes pages which only corp user can visit
     * */
    const corpLoginPages = ['leaderboard', 'CorporateDashboard'];

    // const mobilePages = ['workout'];

    // if (isMobile()) {
    //   if (mobilePages.includes(to.name)) {
    //     next(to.fullPath.replace("workout", "workout-mobile"));
    //     return;
    //   }
    // }

    if (!isAnonymous()) {
      if (nonLoggedInPages.includes(to.name)) {
        next("/");
        return;
      }
      if (corpLoginPages.includes(to.name) && !store.state.userInfo.corporate) {
        next("/");
        return;
      }
    }
    else {
      if (loggedInPages.includes(to.name) || corpLoginPages.includes(to.name)) {
        next("/");
        return;
      }
    }
  }
  next();
}

function getRedirectTo() {
  if (!isAnonymous()) {
    return store.state.defaultLandingPage;
  }
  return '/home';
}

